import { Box, Typography } from "@material-ui/core";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { apiService } from "constants/axiosInstance";
import {
  DEFAULT_MESSAGE,
  SnackbarEmitter,
  SNACKBAR_VARIANT,
} from "constants/snackbarController";
import useDrawFocusBorder from "hooks/useDrawFocusBorder";
import { get } from "lodash";
import React from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import ColumnOptionsList from "./ColumnOptionsList";

const ColumnOptionsGroup = ({
  project,
  taskId,
  defaultSelected = {},
  options = [],
  onEdit = () => {},
  hovering = false,
  setHovering,
  isShared = false,
}) => {
  const isDisplayUpdate =
    get(project, "can_update", false) || get(project, "can_delete", false);
  const location = useLocation();
  const { t } = useTranslation();
  const search = location.search;
  const params = new URLSearchParams(search);
  const projectId = params.get("groupID");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selected, setSelected] = React.useState(defaultSelected);
  useDrawFocusBorder(anchorEl);

  const handleClick = (event) => {
    if (isShared || !isDisplayUpdate) return;
    setAnchorEl(event.currentTarget);
    setHovering(false);
  };

  const _handleClose = () => {
    setAnchorEl(null);
  };

  const _handleSelect = (item) => {
    _handleUpdateProject(
      {
        project_id: project.id,
        project_group_id: projectId,
        priority: item?.value || 0,
      },
      item
    );
  };

  const _handleUpdateProject = async (data, item) => {
    console.log(item);

    try {
      await apiService({
        url: "/project/update",
        method: "PUT",
        data,
      }).then((res) => {
        console.log(res);
        setSelected(item);
        setHovering(false);
      });
      SnackbarEmitter(SNACKBAR_VARIANT.SUCCESS, DEFAULT_MESSAGE.MUTATE.SUCCESS);
    } catch (error) {
      SnackbarEmitter(
        SNACKBAR_VARIANT.ERROR,
        get(error, "message", DEFAULT_MESSAGE.MUTATE.ERROR)
      );
    }
  };

  const _renderSelected = () => {
    if ((!selected?._id || hovering) && isDisplayUpdate && !isShared)
      return (
        <LabelColumnOption
          style={{
            background: "white",
            color: "black",
            width: "auto",
            border: "1px solid #e6e6e6",
          }}
          className="item_on_hover"
          onClick={handleClick}
        >
          + {t("Ưu tiên")}
        </LabelColumnOption>
      );

    return (
      <LabelColumnOption
        style={{ background: selected.color, width: "auto" }}
        onClick={handleClick}
      >
        {selected.name}
      </LabelColumnOption>
    );
  };

  return (
    <>
      <BoxColLabel onClick={handleClick}>{_renderSelected()}</BoxColLabel>
      <ColumnOptionsList
        selected={selected}
        anchorEl={anchorEl}
        options={options}
        isDisplayEditField={false}
        onClose={_handleClose}
        onSelect={_handleSelect}
      />
    </>
  );
};

const BoxColLabel = styled(Box)`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: space-between;
  cursor: pointer;
  .default_tag,
  .icon {
    visibility: hidden;
  }
  &:hover {
    .default_tag,
    .icon {
      visibility: visible;
    }
  }
`;

const LabelColumnOption = styled.div`
  // border-radius: 10px;
  // box-sizing: border-box;
  // -webkit-print-color-adjust: exact;
  // color-adjust: exact;
  // display: block;
  // font-size: 12px;
  // font-weight: 400;
  // height: 20px;
  // line-height: 20px;
  // overflow: hidden;
  // padding: 0 8px;
  // text-align: left;
  // white-space: nowrap;
  // color: #fff;
  // text-overflow: ellipsis;
  // overflow: hidden;
  // white-space: nowrap;
  padding: 3px 10px;
  border-radius: 15px;
  color: #fff;
  max-width: 100%;
  margin: 0px 5px;
  font-weight: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 11px;
  width: auto;
`;

export default ColumnOptionsGroup;
